import React from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner.jpg";
import aboutInfo from "../../assets/images/about-us1.png";
import Footer from "../../components/common/Footer";
import Team from "./Team";
import Cta from "../../components/common/Cta";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      <Helmet>
        <title>Crafting Digital Experiences, Empowering Your Vision</title>
      </Helmet>
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"About Roliox Alloys"}
        subtitle={"Leading Aluminum Recycling & Ingot Manufacturing Company"}
      />
      <div className="site-content">
        <div className="about-area ptb-80">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12">
                <div className="ml-about-img">
                  <img
                    alt="image"
                    loading="lazy"
                    decoding="async"
                    data-nimg="1"
                    className="img-width"
                    src={aboutInfo}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div
                  className={`ml-about-content service-animate ${inView1 ? "visible" : ""
                    }`}
                  ref={ref1}
                >
                  <h2>WHO WE ARE </h2>
                  <p>
                    Founded in 2024, Roliox Alloys is a Private Limited company engaged in the manufacturing
                    and supply of high-quality aluminum products including aluminum ingots, cubes, notch bars,
                    and de-oxidizers. We specialize in recycling aluminum scrap such as UBC scrap, aluminum foils,
                    and radiator scrap.
                  </p>

                  <p>
                    With advanced melting and refining processes, we ensure consistent quality, high purity,
                    and reliable supply for industrial applications.
                  </p>
                </div>
                <div class="about-stats">
                  <div class="stat-box">
                    <h4>High Purity</h4>
                    <p>Maintained through strict refining and testing processes</p>
                  </div>

                  <div class="stat-box">
                    <h4>Bulk Supply</h4>
                    <p>Reliable large-scale production and delivery capability</p>
                  </div>

                  <div class="stat-box">
                    <h4>Quality Control</h4>
                    <p>Every batch tested for consistency and performance</p>
                  </div>

                  <div class="stat-box">
                    <h4>Sustainable Growth</h4>
                    <p>Eco-friendly recycling and resource optimization</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="products">
        <div class="container">
          <h2>Our Products</h2>
          <div class="product-grid">
            <div class="product-card">Aluminum Ingots</div>
            <div class="product-card">Aluminum Cubes</div>
            <div class="product-card">Aluminum Notch Bars</div>
            <div class="product-card">Aluminum Scrap Purchasing</div>
          </div>
        </div>
      </section>
      <div className="ptb-80">
        <div className="container ">
          <div className="about-inner-area">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-6 col-sm-6">
                <div
                  className={`about-text service-animate ${inView2 ? "visible" : ""
                    }`}
                  ref={ref2}
                >
                  <h3>Our History</h3>
                  <p>
                    Our journey began with a vision to create a dependable and quality-driven metal supply business. Starting from humble beginnings, we have steadily grown into a recognized supplier of aluminum products, serving a wide range of industries.
                  </p>
                  <p>
                    Provide high-performance aluminum products that meet global standards
                    Continuously improve our processes through innovation and technology
                    Build long-term relationships with our clients based on trust and transparency
                    Contribute to sustainable and responsible manufacturing practices
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                <div
                  className={`about-text service-animate ${inView3 ? "visible" : ""
                    }`}
                  ref={ref3}
                >
                  <h3>Our Mission</h3>
                  <p>
                    Our mission is to become a leading and reliable partner in the aluminum and metal industry by delivering superior quality products, maintaining ethical business practices, and ensuring complete customer satisfaction.
                  </p>
                  <p>
                    Over the years, we have expanded our capabilities, enhanced our production processes, and built a strong network of clients and partners. Our commitment to quality, timely delivery, and customer-centric approach has been the key to our growth and success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Cta />
    </div>
  );
};

export default AboutUs;
